import React from 'react'
import { FileField } from './ExpandedCell'
import { Form } from '../../../lib/ui/form'
import useBulkSavedRecruitersForm from './useBulkSavedRecruitersForm'
import { Button } from '../../../lib/ui/button'
import useTranslation from '../../shared/TranslationProvider'
import SavedStatusIcon from '~/components/shared/SavedStatusIcon'

const BulkUploadForm = () => {
  const { form, onSubmit, submitted, errors, buttonStatus } =
    useBulkSavedRecruitersForm()
  const { t } = useTranslation('BulkUpload')
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex flex-col">
          <FileField
            control={form.control}
            name="remote_content"
            accept={'csv'}
            label={t('bulk_upload')}
          />
          {errors && <Errors>{errors}</Errors>}
          <div className="hint">{t('bulk_upload_hint')}</div>
        </div>
        <Button type="submit" disabled={submitted} className={'w-full'}>
          {t(buttonStatus)}
          <SavedStatusIcon loadingStatus={buttonStatus} />
        </Button>
      </form>
    </Form>
  )
}
export default BulkUploadForm

const Errors = ({ children }) => {
  return <p className={'text-sm font-medium text-destructive'}>{children}</p>
}
